// Túnel de compra : carrito (Cart.jsx) y checkout (Checkout.jsx).
// Traducción de fr/tunnel.js — las mismas claves, el mismo orden.
// Tono : «tú» en el carrito, «usted» a partir del checkout (como en francés).
export default {
  // --- Carrito (Cart.jsx) ---
  'tunnel.panier.seoTitre': 'Mi carrito',
  'tunnel.panier.seoDescription':
    'Consulta tu carrito Joyful Reveal y finaliza la compra con el pago seguro de Stripe. Si tienes un código promocional, vuelve a introducirlo aquí.',
  'tunnel.panier.titre': '🛒 Tu carrito',
  'tunnel.panier.sousTitreVide':
    'Empieza la aventura reuniendo las piezas del puzle',
  'tunnel.panier.sousTitreUn': 'Tienes {n} pieza en tu carrito',
  'tunnel.panier.sousTitrePlusieurs': 'Tienes {n} piezas en tu carrito',
  'tunnel.panier.retireTitreUn': 'Se ha retirado un artículo de su carrito',
  'tunnel.panier.retireTitrePlusieurs':
    'Se han retirado artículos de su carrito',
  'tunnel.panier.retireDetail':
    '{noms} — este pack ya no se ofrece. Encuentre nuestros packs actuales en la',
  'tunnel.panier.retireDetailLien': 'tienda',
  'tunnel.panier.progression': 'Colección en curso',
  'tunnel.panier.videTitre': 'Carrito vacío',
  'tunnel.panier.videTexte':
    'Aquí no hay nada... ¡todavía! Empieza tu aventura reuniendo las piezas del puzle.',
  'tunnel.panier.videCta': '🎯 Volver a la aventura',
  'tunnel.panier.langue': 'Idioma:',
  'tunnel.panier.retirerDuPanier': 'Quitar del carrito',
  'tunnel.panier.sousTotal': 'Subtotal',
  'tunnel.panier.reduction': 'Descuento ({code})',
  'tunnel.panier.retirer': 'Quitar',
  'tunnel.panier.livraison': 'Envío',
  'tunnel.panier.livraisonADeterminer': 'Por determinar',
  'tunnel.panier.codePromo': 'Código promocional',
  'tunnel.panier.appliquer': 'Aplicar',
  'tunnel.panier.promoAppliquee': '¡Código "{code}" aplicado!',
  'tunnel.panier.total': 'Total',
  'tunnel.panier.offreSpeciale':
    '¡Colección especial desbloqueada! Estás cerca del gran secreto.',
  'tunnel.panier.continuerCollecter': '← Seguir reuniendo piezas',
  'tunnel.panier.procederPaiement': '🎯 Ir al pago',

  // --- Checkout (Checkout.jsx) ---
  'tunnel.checkout.seoTitre': 'Pago - Compra segura',
  'tunnel.checkout.seoDescription':
    'Finalice su compra del puzle Joyful Reveal con toda seguridad gracias a Stripe. Envío rápido a España, Francia y el resto de Europa.',
  'tunnel.checkout.chargement': 'Cargando...',
  'tunnel.checkout.erreur': '❌ Error: {message}',
  'tunnel.checkout.etape': 'Paso {n} / 3',
  'tunnel.checkout.sansCompte':
    '✅ No hace falta crear una cuenta — con su correo electrónico basta para recibir la confirmación y el seguimiento del paquete.',
  'tunnel.checkout.dejaCompte': '¿Ya tiene una cuenta?',
  'tunnel.checkout.dejaCompteLien': 'Inicie sesión',
  'tunnel.checkout.dejaCompteFin': 'para recuperar sus pedidos.',
  'tunnel.checkout.etape1Titre': '📍 Dirección de envío',
  'tunnel.checkout.champNomComplet': 'Nombre completo',
  'tunnel.checkout.champEmail': 'Correo electrónico',
  'tunnel.checkout.champAdresse': 'Dirección',
  'tunnel.checkout.champVille': 'Ciudad',
  'tunnel.checkout.champCodePostal': 'Código postal',
  'tunnel.checkout.choisirPays': 'Elija un país',
  'tunnel.checkout.paysFR': 'Francia',
  'tunnel.checkout.paysBE': 'Bélgica',
  'tunnel.checkout.paysLU': 'Luxemburgo',
  'tunnel.checkout.paysDE': 'Alemania',
  'tunnel.checkout.paysES': 'España',
  'tunnel.checkout.paysIT': 'Italia',
  'tunnel.checkout.paysNL': 'Países Bajos',
  'tunnel.checkout.paysPT': 'Portugal',
  'tunnel.checkout.etape2Titre': '🚚 Método de envío',
  'tunnel.checkout.calculTarifs': 'Calculando las tarifas...',
  'tunnel.checkout.etapeSuivanteRequise': 'Paso siguiente obligatorio',
  'tunnel.checkout.choisirPointRelaisTexte':
    'Seleccione el punto de recogida donde desea retirar su pedido',
  'tunnel.checkout.choisirPointRelaisBouton':
    '🗺️ HAGA CLIC AQUÍ PARA ELEGIR SU PUNTO DE RECOGIDA',
  'tunnel.checkout.pointRelaisSelectionne': '✓ Punto de recogida seleccionado',
  'tunnel.checkout.modifier': 'Modificar',
  // El selector de puntos de recogida es un script externo : puede faltar
  // (red, bloqueador de publicidad). Estos mensajes sustituyen alert() en inglés.
  'tunnel.checkout.selecteurIndisponible':
    'El mapa de puntos de recogida no se ha podido cargar. Recargue la página y, si el problema continúa, desactive su bloqueador de publicidad mientras hace el pedido.',
  'tunnel.checkout.choisirTransporteurDabord':
    'Elija primero un método de envío arriba.',
  'tunnel.checkout.selecteurErreur':
    'El mapa de puntos de recogida no ha respondido. Vuelva a intentarlo en un momento.',
  // Método de envío mostrado en cada opción : Sendcloud devuelve una decena y
  // el nombre del producto no dice dónde llega el paquete.
  'tunnel.checkout.modePointRelais': '📍 Punto de recogida',
  'tunnel.checkout.modeDomicile': '🏠 A domicilio',
  // Solo aparece si la contribución es real. Formulación sobria : se anuncia lo
  // que se hace, sin disculparse por el precio ni subrayarlo.
  'tunnel.checkout.participation': '💚 Asumimos {montant} € de este trayecto',
  // Cierta porque la tarifa viene del transportista, al céntimo : no se le añade
  // ningún margen. Se dice en todos los países, sin señalar a ninguno.
  'tunnel.checkout.portSansMarge':
    'La tarifa mostrada es la del transportista, al céntimo — nosotros no añadimos nada encima.',
  'tunnel.checkout.livraisonDomicileTexte':
    '✓ Entregado directamente en su dirección: {adresse}',
  'tunnel.checkout.indispoTitre':
    '⏳ Envío temporalmente no disponible a este país',
  'tunnel.checkout.indispoTexte':
    'De momento ningún transportista nos ofrece este trayecto. Estamos trabajando para abrirlo — mientras tanto, puede comprobar la dirección introducida (código postal y ciudad), elegir otro país de envío o escribirnos: encontraremos una solución juntos.',
  'tunnel.checkout.indispoModifierAdresse': '← Modificar la dirección',
  'tunnel.checkout.indispoContact': '💬 Contactar con nosotros',
  'tunnel.checkout.voirPlusOptions': '↓ Ver los otros {n} transportistas',
  'tunnel.checkout.voirMoinsOptions': '↑ Mostrar menos opciones',
  'progression.complete': '✨ ¡REVELACIÓN COMPLETA! ✨',
  'progression.restant': 'Quedan {n} piezas por descubrir',
  // Le tunnel de commande compte des ÉTAPES : y afficher « Plus que 23
  // pièces à découvrir » juste au-dessus du bouton de paiement inquiétait
  // l'acheteur au lieu de le rassurer.
  'progression.etapeRestante': "Queda {n} paso antes del pago",
  'progression.etapesRestantes': "Quedan {n} pasos antes del pago",
  'progression.pretAPayer': "Último paso: el pago",
  'tunnel.panier.etape': "Tu cesta",
  'tunnel.checkout.tarifsAttenteLongue':
    'Un momento, la conexión con el transportista está tardando algo más de lo habitual.',
  'tunnel.checkout.tarifsReprise':
    'El transportista no responde, lo intentamos de nuevo ({n}/{total})…',
  'tunnel.checkout.tarifsErreurTitre':
    '⚠️ No hemos podido calcular los gastos de envío',
  'tunnel.checkout.tarifsErreurTexte':
    'Lo hemos intentado tres veces sin éxito. No se debe a su país, sino a nuestra conexión con el transportista. Vuelva a lanzar el cálculo — si el problema persiste, escríbanos y finalizaremos el pedido con usted.',
  'tunnel.checkout.tarifsReessayer': '↻ Reintentar',
  'tunnel.checkout.etape3Titre': '💳 Pago',
  'tunnel.checkout.redirectionStripe':
    'Le vamos a redirigir a una página de pago seguro de Stripe.',
  'tunnel.checkout.redirection': 'Redirigiendo...',
  'tunnel.checkout.procederPaiement': 'Ir al pago seguro →',
  'tunnel.checkout.retour': '← Volver',
  'tunnel.checkout.continuer': 'Continuar →',
  'tunnel.checkout.recapitulatif': '📦 Resumen',
  'tunnel.checkout.recapLivraison': '🚚 Envío ({nom})',
  'tunnel.checkout.recapReduction': '🏷️ Descuento ({code})',
  'tunnel.checkout.total': 'Total:',
  'tunnel.checkout.paiementReussi': '¡Pago realizado!',
};
